import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
    getAppTimeZone,
    setAppTimeZone,
} from "utils/timezones";

const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {
    const [timeZone, setTimeZoneState] = useState(getAppTimeZone);

    useEffect(() => {
        setAppTimeZone(timeZone);
    }, [timeZone]);

    const setTimeZone = useCallback((nextTimeZone) => {
        setTimeZoneState(setAppTimeZone(nextTimeZone));
    }, []);

    const value = useMemo(
        () => ({ timeZone, setTimeZone }),
        [timeZone, setTimeZone]
    );

    return (
        <TimezoneContext.Provider value={value}>
            {children}
        </TimezoneContext.Provider>
    );
};

export const useTimezone = () => {
    const context = useContext(TimezoneContext);
    if (!context) {
        throw new Error("useTimezone must be used within a TimezoneProvider");
    }
    return context;
};
